"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePromotionSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
const ad_1 = require("./ad");
const video_1 = require("./video");
exports.BasePromotionSchema = __1.BaseSchema.extend({
    type: zod_1.z.nativeEnum(__1.PromotionType),
    target: zod_1.z.nativeEnum(__1.PromotionTarget).optional(),
    name: __1.ShortStringSchema.optional(),
    code: __1.ShortStringSchema.optional(),
    startsAt: zod_1.z.coerce.date().optional(),
    endsAt: zod_1.z.coerce.date().optional(),
    deactivatedAt: zod_1.z.coerce.date().optional(),
    usageCount: zod_1.z.number().optional(),
    applications: zod_1.z.nativeEnum(__1.PromotionApplication).array().optional(),
    originalPrice: __1.MoneySchema.optional(),
    promotionPrice: __1.MoneySchema.optional(),
    promotionPercent: zod_1.z.number().optional(),
    promotionLabel: __1.ShortStringSchema.optional(),
    promotionPriceOff: __1.MoneySchema.optional(),
    showBeforeAndAfterPrice: zod_1.z.boolean().optional(),
    status: zod_1.z.nativeEnum(__1.PromotionStatus),
    category: __1.ItemCategoryPartialWithIdSchema.pick({
        id: true,
        name: true,
        parent: true,
        hasChildren: true,
    })
        .extend({
        parent: __1.ItemCategoryPartialWithIdSchema.pick({ id: true, name: true }).optional(),
    })
        .optional(),
    store: __1.BaseStoreSchema.partial()
        .omit({
        storefrontPreferences: true,
        lastFeedback: true,
    })
        .required({ id: true }),
    ads: ad_1.PromotionAdSchema.array().optional(),
    video: video_1.PromotionVideoSchema.optional(),
    shareUrl: zod_1.z.string().url().optional(),
});
//# sourceMappingURL=base-promotion.js.map